import { Fragment, useMemo } from "react";
import { getItemStyle, getPaths, ItemStyle } from "../../utils";
import { ItemProps } from "../types";
import { BaseSummary } from "./BaseSummary";
import { CardSummary } from "./CardSummary";
import { ArrayLayoutProps } from "@jsonforms/core";
import { Divider } from "../Divider";
import { ItemCountProvider } from "../../item-count-context";
import { Wrapper } from "../Wrapper";
import { ExpandableProvider } from "../../expandable-context";

import { css } from "@emotion/css";

function SummaryComponent(itemStyle: ItemStyle, summaryProps: ItemProps) {
  return itemStyle === ItemStyle.CARD ? (
    <ExpandableProvider>
      <CardSummary {...summaryProps} />
    </ExpandableProvider>
  ) : (
    <BaseSummary {...summaryProps} />
  );
}

export function Summary(props: ArrayLayoutProps) {
  const paths = getPaths(props.data, props.path);

  const itemStyle = useMemo(
    () => getItemStyle(props.uischema),
    [props.uischema]
  );

  const RenderSummaryComponent = useMemo(() => {
    return (summaryProps: ItemProps) => {
      return SummaryComponent(itemStyle, summaryProps);
    };
  }, [itemStyle]);

  return (
    <ItemCountProvider>
      <div className={styles.layout}>
        <Wrapper {...props} paths={paths}>
          {({ path }, isOpen, index) => {
            const summaryProps = {
              ...props,
              isOpen,
              index,
              path,
              parentPath: props.path,
            };
            return (
              <Fragment key={path}>
                <Divider {...props} index={index} />
                <RenderSummaryComponent {...summaryProps} />
              </Fragment>
            );
          }}
        </Wrapper>
      </div>
    </ItemCountProvider>
  );
}

const styles = {
  layout: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
};
